import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@mui/material';
import { useSelector } from 'react-redux';

function OpuPregnancyTable() {
  const borderRight = { borderRight: '1px solid rgba(224, 224, 224, 1)' };
  const { data } = useSelector((state) => state.dataAnalyticsReducer);
  const getCellData = (key, index) => {
    if (!data || !data[index] || !data[index].transferDetails) {
      return 'N/A';
    }
    const transferDetails = data[index].transferDetails;

    if (key === 'gender') {
      let gender = '';
      for (let i = 0; i < transferDetails.gender.length; i++) {
        if (transferDetails.gender[i] === 'Male') {
          gender += 'M ';
        } else {
          gender += 'F ';
        }
      }

      return gender;
    }

    if (transferDetails[key] === null || transferDetails[key] === '') {
      return 'N/A';
    }
    return transferDetails[key] ?? 'N/A';
  };
  return (
    <Table>
      <TableHead>
        <TableRow>
          <TableCell
            colSpan={14}
            style={{
              fontWeight: 700,
              textAlign: 'center',
              ...borderRight,
            }}
          >
            PREGNANCY AND OUTCOME
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        <TableRow>
          <TableCell style={{ fontWeight: 700 }}>
            b-HCG Positive (Yes/No)
          </TableCell>
          <TableCell style={{ fontWeight: 700 }}>1st b-HCG</TableCell>
          <TableCell style={{ fontWeight: 700 }}>2nd b-HCG</TableCell>
          <TableCell colSpan={3} style={{ fontWeight: 700 }}>
            <div style={{ width: '80px' }}>Biochemical Pregnancy (0/1)</div>
          </TableCell>
          <TableCell style={{ fontWeight: 700 }}>No. of SAC</TableCell>
          <TableCell style={{ fontWeight: 700 }}>
            Clinical Pregnancy (0/1)
          </TableCell>
          <TableCell style={{ fontWeight: 700 }}>FHR (0/1)</TableCell>
          <TableCell style={{ fontWeight: 700 }}>
            Ectopic Pregnancy/ Misccariage
          </TableCell>
          <TableCell style={{ fontWeight: 700 }}>No. of Children</TableCell>
          <TableCell style={{ fontWeight: 700 }}>Gender</TableCell>
          <TableCell style={{ fontWeight: 700, ...borderRight }}>
            Comments
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell colSpan={14}>
            <div style={{ height: '20px' }}></div>
          </TableCell>
        </TableRow>

        {data &&
          data.map((_, index) => (
            <TableRow key={index}>
              <TableCell>
                <div
                  style={{
                    height: '60px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {getCellData('bhcgPositive', index)}{' '}
                </div>
              </TableCell>
              <TableCell>
                <div
                  style={{
                    height: '60px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {getCellData('bhcgValue1', index)}
                </div>
              </TableCell>
              <TableCell>
                <div
                  style={{
                    height: '60px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {getCellData('bhcgValue2', index)}
                </div>
              </TableCell>
              <TableCell colSpan={3}>
                <div
                  style={{
                    height: '60px',
                    display: 'flex',
                    alignItems: 'center',
                    width: '80px',
                  }}
                >
                  {getCellData('biochemicalPregnany', index)}
                </div>
              </TableCell>
              <TableCell>
                <div
                  style={{
                    height: '60px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {getCellData('noOfSAC', index)}
                </div>
              </TableCell>
              <TableCell>
                <div
                  style={{
                    height: '60px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {getCellData('clinicalPregnancyDetailsClinical', index)}
                </div>
              </TableCell>
              <TableCell>
                <div
                  style={{
                    height: '60px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {getCellData('FHR', index)}
                </div>
              </TableCell>
              <TableCell>
                <div
                  style={{
                    height: '60px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {getCellData('ectopic', index)}
                </div>
              </TableCell>
              <TableCell>
                <div
                  style={{
                    height: '60px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {getCellData('noOfChildren', index)}
                </div>
              </TableCell>
              <TableCell>
                <div
                  style={{
                    height: '60px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {getCellData('gender', index)}
                </div>
              </TableCell>
              <TableCell style={borderRight}>
                <div
                  style={{
                    height: '60px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {getCellData('liveBirthDetailsComments', index)}
                </div>
              </TableCell>
            </TableRow>
          ))}
      </TableBody>
    </Table>
  );
}

export default OpuPregnancyTable;
